import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";

// Core components
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footer/Footer.js";
import { AuthProvider } from "../../src/context/AuthContext";

// ✅ Consent
import { ConsentProvider } from "../../src/consent/ConsentContext";

import CookieBanner from "components/CookieBanner";

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";

import register from "assets/img/register.jpg";
import login from "assets/img/login.jpg";
import lock from "assets/img/lock.jpeg";
import error from "assets/img/clint-mckoy.jpg";
import pricing from "assets/img/bg-pricing.jpeg";

const useStyles = makeStyles(styles);

export default function Pages(props) {
  const { ...rest } = props;
  const wrapper = React.createRef();
  const classes = useStyles();

  React.useEffect(() => {
    document.body.style.overflow = "unset";
  }, []);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) return getRoutes(prop.views);

      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    });
  };

  const getBgImage = () => {
    if (window.location.pathname.includes("/auth/register")) return register;
    if (window.location.pathname.includes("/auth/login")) return login;
    if (window.location.pathname.includes("/auth/pricing")) return pricing;
    if (window.location.pathname.includes("/auth/lock")) return lock;
    if (window.location.pathname.includes("/auth/error")) return error;

    return login;
  };

  const getActiveRoute = (routes) => {
    let activeRoute = "Auth";

    routes.forEach((route) => {
      if (window.location.href.includes(route.layout + route.path)) {
        activeRoute = route.name;
      }
    });

    return activeRoute;
  };

  return (
    <ConsentProvider>
      <AuthProvider>
        <div>
          <AuthNavbar brandText={getActiveRoute(routes)} {...rest} />

          <div className={classes.wrapper} ref={wrapper}>
            <div
              className={classes.fullPage}
              style={{
                backgroundImage: "url(" + getBgImage() + ")",
              }}
            >
              <Switch>
                {getRoutes(routes)}
                <Redirect from="/auth" to="/auth/login-page" />
              </Switch>

              <Footer white />
            </div>
          </div>

          {/* ✅ Cookie Banner */}
          <CookieBanner />
        </div>
      </AuthProvider>
    </ConsentProvider>
  );
}
